
const MieszkaniecDaneWodaRozliczenieWydrukAdresat = props => {
    
    const { mieszkaniec, adres } = props;    

    return (
        <section
            style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "30px",
                fontSize: "0.9rem"
            }}
        >
            <div
                style={{width: "250px", fontWeight: "700", fontSize: "0.8rem"}}
            >
                <p>Sz. P.</p>
                <p>{`${mieszkaniec?.imie_nazwisko}`}</p>
                <p>{adres}</p>
                <p>66-400 Gorzów Wlkp.</p>
            </div>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukAdresat;